
import {
  Component, Watch, Prop, Mixins,
} from 'vue-property-decorator';
import { debounce } from 'ts-debounce';
import { OrderInfo } from '@/features/shipment/types';
import NoContentWithHint from '@/features/shipment/components/createShipment/NoContentWithHint.vue';
import { getOrdersListing } from '@/features/shipment/services/orders-listing.service';
import eventBus from '@/features/common/eventBus';
import NoResultsFound from '@/features/common/components/NoResultsFound.vue';
import eventNames from '@/features/common/constants/events';
import ResponsivenessMixin from '@/features/common/mixins/responsivenessMixin';
import { defaultOffsetLimit } from '@/features/common/raw';
import { showErrorAlertDialog } from '@/features/common/helpers';
import OrdersListingTable from './OrdersListingTable.vue';
import OrdersListingItem from './OrdersListingItem.vue';

@Component({
  components: {
    OrdersListingTable,
    OrdersListingItem,
    NoContentWithHint,
    NoResultsFound,
  },
})

export default class OrdersListing extends Mixins(ResponsivenessMixin) {
  @Prop({ required: true }) platformId!: number;

  private isLoading = false;

  private orders: OrderInfo[] = [];

  private requestCallCount = 1;

  private searchField = '';

  get orderItemHeight(): number {
    if (this.isDesktop) {
      return 77;
    }

    return this.isMobile ? 170 : 100;
  }

  @Watch('platformId', {
    immediate: true,
  })
  private fetchOrders(platformId: number) {
    if (!platformId) return;

    this.fetchOrdersListing('');
  }

  created(): void {
    eventBus.$on(eventNames.SHIPMENT_CLEAR_ALL_INPUTS, this.clearSearchInput);
  }

  destroyed(): void {
    eventBus.$off(eventNames.SHIPMENT_CLEAR_ALL_INPUTS, this.clearSearchInput);
  }

  private clearSearchInput() {
    this.searchField = '';
  }

  private searchOrderItem(value: string) {
    this.requestCallCount = 1;
    this.debounceSearch(value);
  }

  private debounceSearch = debounce(this.fetchOrdersListing, 500);

  private async fetchOrdersListing(value: string): Promise<void> {
    this.isLoading = true;

    const items = await getOrdersListing(this.platformId, {
      search: value,
    });
    if (items === null) {
      showErrorAlertDialog();
    } else {
      this.orders = items;
    }

    this.isLoading = false;
  }

  private async fetchMoreOrdersListing(): Promise<void> {
    const orders = await getOrdersListing(this.platformId, {
      offset: defaultOffsetLimit * this.requestCallCount,
      search: this.searchField,
    });

    if (orders.length) {
      this.orders = [...this.orders, ...orders];
      this.requestCallCount += 1;
    }
  }
}
